module.exports = __webpack_public_path__ + "static/media/tooltip-icon-active.ca543203.svg";